<form [formGroup]="configurationFormFileFilter">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="lowerPriceLimit"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.price-lower-limit'
        |
        translate}}</label>
      <ejs-numerictextbox id="lowerPriceLimit" formControlName="lowerPriceLimit" format="n2" min="0" step="1">
      </ejs-numerictextbox>
    </div>
    <div class="form-group col-md-4">
      <label for="filterCustomerReference"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.items-with-cust-ref'
        |
        translate}}</label>
      <app-yes-no-group-button id="filterCustomerReference" formControlName="filterCustomerReference">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="filterEAN"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.items-with-ean'
        |
        translate}}</label>
      <app-yes-no-group-button id="filterEAN" formControlName="filterEAN"></app-yes-no-group-button>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="filterFixPrice" class="control-label">
        {{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.items-with-dedicated-fixed-price'
        | translate}}
      </label>
      <app-yes-no-group-button id="filterFixPrice" formControlName="filterFixPrice"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="clearingItemFilter"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.clearing-item-filter'
        |
        translate}}</label>
      <app-enum-drop-down-list formControlName="clearingItemFilter"
                               [showClearButton]="false"
                               [enumType]="ClearingItemFilter"
                               baseTranslationString='i18n.shared.clearingItemFilter.'>
      </app-enum-drop-down-list>
    </div>
    <div class="form-group col-md-4">
      <label for="additionalStockLocation"
        class="control-label">{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.additional-stock-location'
        |
        translate}}</label>
      <app-enum-drop-down-list id="additionalStockLocation" formControlName="additionalStockLocation" [showClearButton]="true"
        [enumType]="AdditionalStockLocation" baseTranslationString='i18n.shared.additionalStockLocation.'>
      </app-enum-drop-down-list>
      </div>
  </div>
</form>
<div class="form-row row">
  <div class="col-md-6">
    <app-configuration-form-file-filter-brand-sub [brandSubBrandFilter]="brandSubBrandFilter"
      (gridDataChanged)="onBrandSubFilterChanged($event)"
      title="{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand-exclusion' | translate}}">
    </app-configuration-form-file-filter-brand-sub>
  </div>
  <div class="col-md-6">
    <app-configuration-form-file-filter-brand-sub [brandSubBrandFilter]="brandSubBrandIncludeFilter"
      (gridDataChanged)="onBrandSubIncludeFilterChanged($event)"
      title="{{'i18n.domain.export-configuration.configurations.forms.file.filter-configuration.form-fields.brand-inclusion' | translate}}">
    </app-configuration-form-file-filter-brand-sub>
  </div>
</div>